import React from 'react';
import Header from './Header';
import TestimonialCard from './TestimonialCard';
import SignUpForm from './SignUpForm';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';

const testimonials = [
  {
    id: 1,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/902ea8595168f3b0ea80e450eaeeaed64de78a89e879e3e7bc1b1adf1e4a804b?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  },
  {
    id: 2,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/2c3bd3b5eb2afba3430bb144ffde997b9a25e5b615d82a94b7877e233ec365d4?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  },
  {
    id: 3,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/a6af0ae2ab9cf5a19e7dba986972778140edce3ea63402ddc0ff106ad32ea7da?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  }
];

function SignUpPage() {
  return (
    <main className="bg-background text-foreground min-h-screen flex justify-center">
      <Container size="default" className="w-full mx-12">
        <Header />
        <Inline spacing="md" align="start" className="mt-[52px] gap-5">
          <Stack spacing="lg" className="mt-[55px] ml-2.5 flex-1 min-w-0">
            {testimonials.map(testimonial => (
              <TestimonialCard key={testimonial.id} {...testimonial} />
            ))}
          </Stack>
          <div className="flex-1 min-w-0">
            <SignUpForm />
          </div>
        </Inline>
      </Container>
    </main>
  );
}

export default SignUpPage;
